// ⚠️ These are the `?tab=` URL values, not labels. Renaming one silently breaks
// every link that still carries the old value: an unknown `?tab=` falls back to
// the promo tab (see OrdersHistoryPage). Always route through SHOP_TAB instead of
// writing the string, so a rename stays a one-line change here.
export const SHOP_TAB = {
  promo: "promo-orders",
  instore: "semi-permanent",
} as const;

export type ShopTab = (typeof SHOP_TAB)[keyof typeof SHOP_TAB];

// i18n keys, NOT display strings: every consumer must run these through `t()`.
// "instore" reuses `rituals.NONpromoOrders` (also on the dashboard button) so the
// concept has one label everywhere.
export const TAB_LABELS: Record<ShopTab, string> = {
  [SHOP_TAB.promo]: "rituals.promoOrders",
  [SHOP_TAB.instore]: "rituals.NONpromoOrders",
};
